document.addEventListener("DOMContentLoaded", function () {
    let dropzoneElement = document.querySelector("#myDropzone");
    let fileInput = document.querySelector("#fileInput");
    let form = document.querySelector("#dropzoneForm");

    if (!dropzoneElement) {
        return;
    }

    let dropzone = new Dropzone(dropzoneElement, {
        url: form.action,
        autoProcessQueue: true,
        maxFiles: 1,
        acceptedFiles: ".xlsx,.xls,.csv",
        addRemoveLinks: true,
        dictCancelUpload: "Cancel",
        dictRemoveFile: "✖",
        dictDefaultMessage: `
            <div class="dz-message">
                <i class="bi bi-upload"></i>
                <p>Drop files here or click to upload</p>
            </div>
        `,
        previewTemplate: `
            <div class="dz-preview dz-file-preview">
                <div class="dz-progress">
                    <span class="dz-upload" data-dz-uploadprogress></span>
                </div>
                <div class="dz-file-details">
                    <i class="bi bi-file-earmark-excel"></i>
                    <div class="dz-filename"><span data-dz-name></span></div> 
                </div>
                <div class="dz-remove">
                    <a href="javascript:void(0);" data-dz-remove>✖</a>
                </div>
            </div>
        `
    });

    dropzone.on("addedfile", function (file) {
        let dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        fileInput.files = dataTransfer.files;
    });

    dropzone.on("sending", function (file, xhr, formData) {
        let csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute("content");
        formData.append("_token", csrfToken);
    });


    dropzone.on("removedfile", function () {
        fileInput.value = "";
    });

    dropzone.on("success", function (file, response) {
        setTimeout(() => {
            let progressElement = file.previewElement.querySelector(".dz-progress");
            if (progressElement) {
                progressElement.remove();
            }
        }, 500);
    });
});
